/**
 * MonthLabels component - Displays month labels above calendar weeks
 */

import React from 'react'
import { Typography } from 'antd'

const { Text } = Typography

interface MonthLabelsProps {
  /** Array of month labels with their span (number of days) */
  labels: { month: string; span: number }[]
}

/**
 * MonthLabels displays month names above the calendar grid
 * Used when a week spans multiple months
 */
export const MonthLabels: React.FC<MonthLabelsProps> = ({ labels }) => {
  if (labels.length === 0) return null

  return (
    <div className="mini-calendar-month-row">
      {labels.map(({ month, span }, index) => (
        <Text
          key={index}
          strong
          className="mini-calendar-month-label"
          style={{ width: `${span * 2.1875}rem` }}
        >
          {month}
        </Text>
      ))}
    </div>
  )
}
